import React, { useState } from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import { Button, FormField, FormSection, FormTextArea } from '../../../../../components/ui';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';
import { exportFormFieldsToXlsx } from '../../utils/formExportUtils';
import FormPreviewDialog from '../fields/FormPreviewDialog';

export default function FormOverviewSection({ studio }) {
  const { semantic, typographyStyles } = useFeatureTheme();
  const [previewOpen, setPreviewOpen] = useState(false);
  const form = studio.form || {};
  const useForAi = form.use_for_ai === 1 || form.use_for_ai === true;

  const handleExport = async () => {
    await exportFormFieldsToXlsx(
      form.leads_form_items,
      form.leads_form_name || 'LeadForm'
    );
  };

  return (
    <Box>
      <FormSection title="Form details" description="Name, description and AI usage for this form.">
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
          <Button variant="outline" icon={<VisibilityOutlined />} onClick={() => setPreviewOpen(true)}>
            Preview
          </Button>
          <Button variant="outline" icon={<FileDownloadOutlined />} onClick={handleExport}>
            Export XLSX
          </Button>
        </Box>

        <FormField
          label="Form name"
          required
          value={form.leads_form_name || ''}
          onChange={(event) => studio.updateFormMeta({ leads_form_name: event.target.value })}
          error={Boolean(studio.formErrors?.leads_form_name)}
          helperText={studio.formErrors?.leads_form_name || ''}
          sx={{ mb: 2 }}
        />

        <FormTextArea
          label="Description"
          value={form.description || ''}
          onChange={(event) => studio.updateFormMeta({ description: event.target.value })}
          minRows={3}
          sx={{ mb: 2 }}
        />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            p: 2,
            borderRadius: 2,
            border: `1px solid ${semantic.borders.border}`,
            bgcolor: semantic.surfaces.surfaceSubtle,
          }}
        >
          <Box>
            <Typography sx={{ ...typographyStyles.bodyText, fontWeight: 600 }}>
              Use for AI
            </Typography>
            <Typography sx={{ ...typographyStyles.caption, color: semantic.text.secondary }}>
              Allow this form to be used in AI workflows.
            </Typography>
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={useForAi}
                onChange={(event) =>
                  studio.updateFormMeta({ use_for_ai: event.target.checked ? 1 : 0 })
                }
              />
            }
            label={useForAi ? 'Enabled' : 'Disabled'}
          />
        </Box>
      </FormSection>

      <FormPreviewDialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        fields={form.leads_form_items}
      />
    </Box>
  );
}
